import React from 'react';
import { Moment } from 'moment';
import ConfigUtility from 'Core/ConfigUtility';
import moment from 'moment';
import ShowIfTrue from '../ShowIfTrue';
interface Props {
  date?: Moment;

}

export default ({ date }: Props) => {
  let config = ConfigUtility.getSync();
  let currentTimezone = moment().utcOffset() / 60;
  return <ShowIfTrue condition={currentTimezone != config?.Display.StandardTimeZone} ><label>Pickup Date has been converted to date in Jamaica : {date?.utcOffset(config!.Display.StandardTimeZone)?.format(config?.Display.LongDateFormat)}</label></ShowIfTrue>;
}